import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Documents: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M22.68 10.299c.71.803 1.12 1.884 1.144 3.019-.007 1.121.368 2.203 1.047 3.02.358.417.788.748 1.264.97a3.38 3.38 0 001.5.323h19.567a2.184 2.184 0 011.194.269c.283.156.537.373.746.64.21.268.37.579.473.916.103.337.147.694.128 1.05V46.96a3.002 3.002 0 01-.237 1.35 2.71 2.71 0 01-.567.846c-.236.237-.51.419-.809.535a2.144 2.144 0 01-.928.145H6.545c-.433.026-2.324-.043-2.413-.336-.103-.337-.147-2.184-.128-2.54V11.88a3.006 3.006 0 01.237-1.35c.139-.322.33-.609.567-.846.236-.236.51-.418.809-.535.298-.117.613-.166.928-.144h13.468c1.003.028 1.958.49 2.668 1.294z"
                fill="#fff"
                stroke={props.color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M10.487 25.744a1 1 0 01.967-.744h44.721a1 1 0 01.967 1.256L50.988 49.47a1 1 0 01-.967.743H5.3a1 1 0 01-.967-1.256l6.154-23.213z"
                fill="#fff"
                stroke={props.color}
            />
            <Path
                d="M24.824 13.324v-.028c-.03-1.356-.518-2.668-1.394-3.66-.879-.994-2.09-1.595-3.39-1.63l-.014-.001H6.576a3.145 3.145 0 00-1.323.213c-.433.17-.824.43-1.154.76a3.71 3.71 0 00-.776 1.157 4.005 4.005 0 00-.317 1.368h0v.005a4.47 4.47 0 00-.002.394v35.036c-.01.248-.001.815.02 1.338.01.281.025.57.045.815.016.201.043.494.106.701a1.16 1.16 0 00.565.673c.36.449.917.748 1.56.748H50.02a2 2 0 001.933-1.487l6.154-23.213A2 2 0 0056.175 24h-5.432v-3.469a4.046 4.046 0 00-.171-1.367 3.818 3.818 0 00-.643-1.24 3.457 3.457 0 00-1.052-.9 3.185 3.185 0 00-1.32-.39l-.008-.001a3.392 3.392 0 00-.375-.002H27.616a2.382 2.382 0 01-1.057-.228 2.774 2.774 0 01-.924-.71c-.516-.625-.817-1.471-.81-2.369z"
                stroke={props.color}
                strokeWidth={2}
            />
        </Svg>
    );
};

export default React.memo(Documents);
